import { Text, Box, Badge, Flex, Image } from "@mantine/core";
import useStyles from "./style";

const SkypointOverviewSection = () => {
  const { classes } = useStyles();
  return (
    <Box
      className={`${classes.skypointOverviewSection} ${classes.InlinePadding}`}
    >
      <Image
        src={"/assets/images/overviewSecLeftImg.png"}
        width={245}
        className="leftImg"
      />
      <Box className="contentBox">
        <Text className="title">Your Skypoint</Text>
        <Text className="heading">We are simple, fast and seemless</Text>
        <Text className="description">
          Our platform is built with both healthcare professionals, contractors
          and clients in mind. The user-friendly interface ensures that you can
          navigate seamlessly through patient records, appointments, billing
          module and medical histories with ease. Experience a robust set of
          tools designed to make your workflow more efficient and effective.
        </Text>
        <Image
          src={"/assets/images/overviewSecBottomImg.png"}
          width={300}
          mt={15}
        />
      </Box>
      <Image
        src={"/assets/images/overviewSecLeftImg.png"}
        width={245}
        className="rightImg"
      />
    </Box>
  );
};

export default SkypointOverviewSection;
